import React from 'react';
import { ValidateRestorePass } from '~/presentation/pages';

export const ValidateRestorePassFactory: React.FC = () => {
  return <ValidateRestorePass />;
};
